(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zt-bundle"] && !Shopify.designMode) return;
  try {
    class ZtBundle extends HTMLElement {
    constructor() {
      super();
      this.tiers = this.querySelectorAll('.zt-b-tier');
      this.modeCards = this.querySelectorAll('.zt-b-mode');
      this.freqBox = this.querySelector('[data-frequency]');
      this.freqChips = this.querySelectorAll('.zt-b-freq__chip');
      this.selectedPlanId = '';
      const firstChip = this.querySelector('.zt-b-freq__chip[aria-pressed="true"]');
      if (firstChip) this.selectedPlanId = (firstChip.dataset.planId || '').trim().split('/').pop();
      this.cartId = this.querySelector('[data-cart-id]');
      this.cartPlan = this.querySelector('[data-cart-plan]');
      this.modeOnePrice = this.querySelector('[data-mode-onetime-price]');
      this.modeSubPrice = this.querySelector('[data-mode-sub-price]');
      this.modeBadge = this.querySelector('[data-mode-badge]');
      this.mode = this.dataset.defaultMode || 'subscription';
      this.tier = this.dataset.defaultTier || '2';
    }
    connectedCallback() {
      this.tiers.forEach(t => t.addEventListener('click', () => this.selectTier(t.dataset.tier)));
      this.modeCards.forEach(m => m.addEventListener('click', () => this.setMode(m.dataset.mode)));
      this.freqChips.forEach(c => c.addEventListener('click', () => this.selectFreq(c)));
      this.selectTier(this.tier);
    }
    selectFreq(chip) {
      this.freqChips.forEach(c => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      this.selectedPlanId = (chip.dataset.planId || '').trim().split('/').pop();
      const active = this.querySelector('.zt-b-tier[aria-pressed="true"]');
      this.applyState(active);
    }
    getPeriodSuffix() {
      const active = this.querySelector('.zt-b-freq__chip[aria-pressed="true"]');
      if (!active) return '/mois';
      const txt = (active.textContent || '').trim().toLowerCase();
      if (txt.includes('2 mois')) return '/2 mois';
      if (txt.includes('3 mois')) return '/3 mois';
      return '/mois';
    }
    selectTier(tierNum) {
      this.tier = tierNum;
      let active = null;
      this.tiers.forEach(t => {
        const isActive = t.dataset.tier === tierNum;
        t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) active = t;
      });
      this.applyState(active);
    }
    setMode(mode) {
      this.mode = mode;
      const active = this.querySelector('.zt-b-tier[aria-pressed="true"]');
      this.applyState(active);
    }
    formatEuro(n) {
      const num = parseFloat(n);
      if (isNaN(num)) return '';
      return num.toFixed(2).replace('.', ',') + ' €';
    }
    applyState(tierEl) {
      if (!tierEl) return;
      const onetimeCents = tierEl.dataset.onetimeCents;
      const subPrice = (tierEl.dataset.subPrice || '').replace(',', '.');
      const planId = this.selectedPlanId || (tierEl.dataset.planId || '').trim().split('/').pop();
      const variantId = tierEl.dataset.variantId;
      const onetimeEur = parseFloat(onetimeCents) / 100;

      this.tiers.forEach(t => {
        const bigEl = t.querySelector('[data-tier-big]');
        const sfxEl = t.querySelector('[data-tier-suffix]');
        const strEl = t.querySelector('[data-tier-strike]');
        const svEl = t.querySelector('[data-tier-save]');
        const oneCts = parseFloat(t.dataset.onetimeCents) / 100;
        const subCts = parseFloat((t.dataset.subPrice || '').replace(',', '.'));
        const cmpCts = parseFloat(t.dataset.compareCents) / 100;
        const sv = t.dataset.subSave;
        if (this.mode === 'subscription') {
          if (bigEl) bigEl.textContent = this.formatEuro(subCts);
          if (sfxEl) sfxEl.textContent = '/mois';
          if (strEl) strEl.textContent = 'ou ' + this.formatEuro(oneCts) + ' une fois';
          if (svEl) svEl.textContent = '−' + sv + ' %';
        } else {
          if (bigEl) bigEl.textContent = this.formatEuro(oneCts);
          if (sfxEl) sfxEl.textContent = '';
          if (strEl) strEl.textContent = 'ou ' + this.formatEuro(subCts) + '/mois en abo';
          const oneSave = Math.round((cmpCts - oneCts) / cmpCts * 100);
          if (svEl) svEl.textContent = '−' + oneSave + ' %';
        }
      });

      const sv = tierEl.dataset.subSave;
      if (this.modeBadge) this.modeBadge.textContent = 'économisez ' + sv + ' %';
      if (this.modeOnePrice) this.modeOnePrice.textContent = this.formatEuro(onetimeEur);
      const periodSuffix = this.getPeriodSuffix();
      if (this.modeSubPrice) this.modeSubPrice.textContent = subPrice ? this.formatEuro(subPrice) + periodSuffix : '—';
      this.modeCards.forEach(m => m.classList.toggle('is-active', m.dataset.mode === this.mode));
      if (this.freqBox) this.freqBox.classList.toggle('is-visible', this.mode === 'subscription');

      if (this.mode === 'subscription' && subPrice) {
        if (this.cartPlan) {
          if (planId) { this.cartPlan.value = planId; this.cartPlan.disabled = false; }
          else { this.cartPlan.value = ''; this.cartPlan.disabled = true; }
        }
      } else {
        if (this.cartPlan) { this.cartPlan.value = ''; this.cartPlan.disabled = true; }
      }
      if (this.cartId) this.cartId.value = variantId;

      const giftProp = this.querySelector('[data-gift-prop]');
      const tn = parseInt(this.tier, 10) || 1;
      if (giftProp) {
        const parts = ['Guide 30 jours', 'Livraison offerte'];
        if (tn === 2) parts.push('Carte parrainage -20%');
        if (tn === 3) parts.push('1 boîte bonus');
        giftProp.value = parts.join(' + ');
        giftProp.disabled = false;
      }
    }
  }
  if (!customElements.get('zt-bundle')) customElements.define('zt-bundle', ZtBundle);

  (function initScarcity() {
    const scarcityEl = document.querySelector('[data-scarcity-count]');
    const fillEl = document.querySelector('[data-scarcity-fill]');
    if (!scarcityEl) return;
    const total = 500; const floor = 12;
    const STORAGE_KEY = 'zt_scarcity_v2';
    let current = parseInt(scarcityEl.textContent, 10) || 87;
    try {
      const cached = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (cached && (Date.now() - cached.ts) < 172800000) {
        current = Math.min(current, cached.value);
        scarcityEl.textContent = current;
        if (fillEl) fillEl.style.width = ((total - current) / total * 100).toFixed(1) + '%';
      }
    } catch(e) {}
    function tick() {
      if (current <= floor) return;
      current = current - 1;
      scarcityEl.textContent = current;
      if (fillEl) fillEl.style.width = ((total - current) / total * 100).toFixed(1) + '%';
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ value: current, ts: Date.now() })); } catch(e) {}
      scheduleNext();
    }
    function scheduleNext() {
      const delay = (45 + Math.random() * 45) * 60 * 1000;
      setTimeout(tick, delay);
    }
    scheduleNext();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["zt-cart-wow"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(e){
      const btn = e.target.closest('[data-zt-upgrade-btn]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const tier = btn.dataset.ztUpgradeTier;
      const variantMap = { '2': 53089435091272, '3': 53089435124040 };
      const fromVariantMap = { '2': 52930801336648, '3': 53089435091272 };
      const newId = variantMap[tier];
      const oldId = fromVariantMap[tier];
      if (!newId) { console.error('[ZT Upgrade] invalid tier', tier); return; }

      btn.classList.add('is-loading');
      btn.setAttribute('disabled','disabled');

      try {
        // 1) Lire le panier pour récupérer la clé et le selling plan de l'ancienne ligne
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!cartRes.ok) throw new Error('cart fetch failed: ' + cartRes.status);
        const cart = await cartRes.json();
        const oldLine = cart.items.find(it => it.variant_id === oldId);
        const sellingPlan = (oldLine && oldLine.selling_plan_allocation) ? oldLine.selling_plan_allocation.selling_plan.id : null;
        const oldKey = oldLine ? oldLine.key : null;

        // 2) Retirer également toute pochette déjà au panier pour éviter doublons
        const pochetteLine = cart.items.find(it => it.variant_id === 53139203359048);
        if (pochetteLine) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: pochetteLine.key, quantity: 0 })
          });
        }

        // 3) Retirer l'ancienne ligne (1 ou 2 boîtes)
        if (oldKey) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: oldKey, quantity: 0 })
          });
        }

        // 4) Ajouter la nouvelle boîte + la (les) pochette(s)
        const items = [];
        const mainItem = { id: newId, quantity: 1 };
        if (sellingPlan) mainItem.selling_plan = sellingPlan;
        items.push(mainItem);
        const giftQty = (tier === '3') ? 2 : 1;
        items.push({ id: 53139203359048, quantity: giftQty, properties: { '_cadeau': 'Offert avec votre commande' } });

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });

        if (!addRes.ok) {
          const txt = await addRes.text();
          throw new Error('add failed: ' + addRes.status + ' ' + txt.slice(0,200));
        }

        // 5) Rafraîchir : reload page = 100 % fiable, drawer reste ouvert ensuite
        window.location.reload();
      } catch (err) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
        console.error('[ZT Upgrade]', err);
        alert('Impossible d\'ajouter la boîte. Réessayez ou actualisez la page.');
      }
    }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["zt-quiz"] && !Shopify.designMode) return;
  try {
    class ZtQuiz extends HTMLElement {
    constructor() {
      super();
      this.answers = {};
      this.baseRec = {
        'test': {
          tier: 1, mode: 'onetime',
          name: '1 boîte',
          price: '39,90 €', compare: '49,90 €',
          gifts: ['Guide PDF « 30 jours »', 'Livraison offerte'],
          title: 'Le format <strong>DÉCOUVERTE</strong>',
          desc: "Idéal pour tester en 30 jours."
        },
        'confort': {
          tier: 2, mode: 'onetime',
          name: '2 boîtes',
          price: '64,90 €', compare: '79,80 €',
          gifts: ['Guide PDF « 30 jours »', 'Carte parrainage −20 %', 'Livraison offerte'],
          title: 'Le format <strong>DUO</strong>',
          desc: 'Le meilleur rapport qualité/cadeaux.'
        },
        'tranquille': {
          tier: 3, mode: 'subscription',
          name: '3 boîtes · abonnement',
          price: '54,90 €', compare: '119,70 €',
          gifts: ['1 boîte bonus offerte', 'Guide PDF', 'Livraison à vie · Annulable'],
          title: "L'<strong>abonnement LIBERTÉ TOTALE</strong>",
          desc: 'Économie maximale, livraison à vie, sans contrainte.'
        }
      };
    }

    connectedCallback() {
      this.querySelectorAll('[data-quiz-next]').forEach(el => el.addEventListener('click', () => this.next()));
      this.querySelectorAll('[data-quiz-answer]').forEach(el => el.addEventListener('click', (e) => this.answer(e)));
      this.querySelectorAll('[data-quiz-restart]').forEach(el => el.addEventListener('click', () => this.restart()));
      this.querySelectorAll('[data-quiz-goto-bundle]').forEach(el => el.addEventListener('click', () => this.gotoBundle()));
      this.querySelectorAll('[data-quiz-see-all]').forEach(el => el.addEventListener('click', () => this.seeAllOffers()));
      this.currentStep = 0;
    }

    setStep(step) {
      this.querySelectorAll('.zt-quiz__step').forEach(el => {
        el.classList.toggle('is-active', String(el.dataset.step) === String(step));
      });
      this.currentStep = step;
      // Scroll top of quiz for visibility
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    next() { this.setStep(1); }

    answer(e) {
      const btn = e.currentTarget;
      const key = btn.dataset.key;
      const val = btn.dataset.val;
      const step = parseInt(btn.dataset.quizAnswer, 10);
      this.answers[key] = val;
      btn.classList.add('is-selected');
      setTimeout(() => {
        if (step < 4) this.setStep(step + 1);
        else this.showResult();
      }, 260);
    }

    computeRecommendation() {
      const priority = this.answers.q4 || 'confort';
      let rec = Object.assign({}, this.baseRec[priority]);
      const household = parseInt(this.answers.q3 || '1', 10);
      const freq = this.answers.q2 || 'ponctuel';

      if (household >= 3) {
        rec = Object.assign({}, this.baseRec['tranquille']);
        rec.title = "L'<strong>abonnement 3 boîtes</strong>";
        rec.desc = "Pour toute la famille.";
      } else if (household === 2 && rec.tier === 1) {
        rec = Object.assign({}, this.baseRec['confort']);
        rec.title = 'Le format <strong>2 boîtes</strong>';
        rec.desc = "Pour deux personnes.";
      }

      if (freq === 'quotidien' && rec.tier < 3 && household < 3) {
        rec.tier = 3;
        rec.mode = 'onetime';
        rec.name = '3 boîtes';
        rec.price = '84,90 €';
        rec.compare = '119,70 €';
        rec.gifts = ['1 boîte bonus', 'Guide PDF', 'Livraison offerte'];
        rec.title = 'Le format <strong>LIBERTÉ TOTALE</strong>';
        rec.desc = "Pour un usage quotidien.";
      }
      return rec;
    }

    showResult() {
      const rec = this.computeRecommendation();
      this.querySelector('[data-result-title]').innerHTML = rec.title;
      this.querySelector('[data-result-desc]').textContent = rec.desc;
      this.querySelector('[data-result-price]').textContent = rec.price;
      this.querySelector('[data-result-compare]').textContent = rec.compare;
      const giftsEl = this.querySelector('[data-result-gifts]');
      giftsEl.innerHTML = '';
      rec.gifts.forEach(g => {
        const li = document.createElement('li');
        li.textContent = g;
        giftsEl.appendChild(li);
      });
      this.recommendedTier = rec.tier;
      this.recommendedMode = rec.mode;
      try {
        sessionStorage.setItem('zt-recommended-tier', String(rec.tier));
        sessionStorage.setItem('zt-recommended-mode', rec.mode);
      } catch(e) {}
      this.setStep('result');
    }

    restart() {
      this.answers = {};
      this.querySelectorAll('.zt-quiz__card.is-selected').forEach(el => el.classList.remove('is-selected'));
      this.setStep(0);
    }

    revealBundle(tier, mode) {
      const bundle = document.querySelector('zt-bundle');
      if (!bundle) return null;
      bundle.removeAttribute('data-zt-hidden');
      bundle.style.opacity = '0';
      requestAnimationFrame(() => { bundle.style.opacity = '1'; });
      try {
        if (tier) {
          const tierBtn = bundle.querySelector('.zt-tier[data-tier="' + tier + '"]');
          if (tierBtn) tierBtn.click();
        }
        if (mode) {
          const modeCard = bundle.querySelector('.zt-mode[data-mode="' + mode + '"]');
          if (modeCard) modeCard.click();
        }
      } catch(e) {}
      return bundle;
    }

    hideQuiz() {
      this.style.display = 'none';
    }

    gotoBundle() {
      const bundle = this.revealBundle(this.recommendedTier || 2, this.recommendedMode || 'onetime');
      this.hideQuiz();
      const target = document.querySelector(this.dataset.bundleAnchor) || bundle;
      if (target) setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    }

    seeAllOffers() {
      const bundle = this.revealBundle(null, null);
      this.hideQuiz();
      const target = document.querySelector(this.dataset.bundleAnchor) || bundle;
      if (target) setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    }
  }
  if (!customElements.get('zt-quiz')) customElements.define('zt-quiz', ZtQuiz);
  } catch(e) { console.error(e); }
})();

})();
